<template>
  <div>
    <loading :active.sync="isLoading"></loading>
    <div class="row">
      <div class="col">
        <h3>Reviews</h3>
      </div>
    </div>
    <div class="row" v-if="getUserType !== 'business'">
      <div class="col">
        <i v-on:click="setRating = yourRating"
           @mouseover="yourRating = 1"
           @mouseout="yourRating = setRating"
           class="fa-star"
           v-bind:class="{ fas: yourRating >= 1 , far: yourRating < 1 }"></i>
        <i v-on:click="setRating = yourRating"
           @mouseover="yourRating = 2"
           @mouseout="yourRating = setRating"
           class="fa-star"
           v-bind:class="{ fas: yourRating >= 2 , far: yourRating < 2 }"></i>
        <i v-on:click="setRating = yourRating"
           @mouseover="yourRating = 3"
           @mouseout="yourRating = setRating"
           class="fa-star"
           v-bind:class="{ fas: yourRating >= 3 , far: yourRating < 3 }"></i>
        <i v-on:click="setRating = yourRating"
           @mouseover="yourRating = 4"
           @mouseout="yourRating = setRating"
           class="fa-star"
           v-bind:class="{ fas: yourRating >= 4 , far: yourRating < 4 }"></i>
        <i v-on:click="setRating = yourRating"
           @mouseover="yourRating = 5"
           @mouseout="yourRating = setRating"
           class="fa-star"
           v-bind:class="{ fas: yourRating === 5 , far: yourRating !== 5 }"></i>
        <div class="form-group">
          <textarea v-model="reviewText" class="form-control no-padding padding-bottom" rows="5" id="comment"></textarea>
          <!--<div class="custom-file">
            <input @change="previewImage" type="file" class="custom-file-input" id="customFile">
            <label class="custom-file-label" for="customFile">Choose Image</label>
          </div>-->
          <img v-for="(image, index) in imageData"
               class="preview-image"
               v-bind:key="index"
               v-bind:src="image"
               v-on:click="removeImage(index)"
               alt="not working"
               height="100px"/>
          <button v-on:click="submitReview" class="btn btn-primary">Submit</button>
          <b-alert variant="warning"
                   dismissible
                   :show="dataNotFilledIn"
                   @dismissed="dataNotFilledIn=false">
            You must give a rating and a review.
          </b-alert>
          <b-alert variant="warning"
                   dismissible
                   :show="notSignedIn"
                   @dismissed="notSignedIn=false">
            You must must be signed in to write a review.
          </b-alert>
          <router-link to="/profile/user/details">
            <b-alert variant="warning"
                     dismissible
                     :show="noName"
                     @dismissed="noName=false">
              You must have a first name.
            </b-alert>
          </router-link>
          <b-alert variant="warning"
                   dismissible
                   :show="mustBeUser"
                   @dismissed="this.mustBeUser=false">
            You must use a user account.
          </b-alert>
        </div>
      </div>
    </div>
    <review v-for="review in homAptReviews"
            :key="review.review_id"
            :rating="review.rating"
            :profilePic="review.reviewer_profile_image"
            :review="review.review"
            :datePosted="review.date"
            :reviewer="review.reviewer_name"
            :reviewerId="review.reviewer_id"
            :reviewId="review.review_id"
            v-on:reload="reload"
            v-on:loading="setLoading"></review>
    <review v-for="review in googleReviews"
            :key="review.id"
            :rating="review.rating"
            :profilePic="review.profile_photo_url"
            :review="review.text"
            :datePosted="review.datePosted"
            :reviewer="review.author_name"></review>
    <button v-on:click="loadMoreReviews" class="btn btn-primary">Load More Reviews</button>
  </div>
</template>

<script>
import review from './Review.vue'
import { mapGetters } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  created () {
    this.getReviews()
  },
  props: {
    googleReviews: Array,
    businessId: String
  },
  data () {
    return {
      imageData: [],
      yourRating: null,
      setRating: null,
      reviewText: '',
      homAptReviews: [],
      lastKey: null,
      dataNotFilledIn: false,
      notSignedIn: false,
      noName: false,
      mustBeUser: false,
      isLoading: false
    }
  },
  components: {
    review,
    Loading
  },
  computed: {
    ...mapGetters([
      'getIdProvider'
    ]),
    ...mapGetters('user', {
      getUserType: 'getUserType',
      getLegalFirstName: 'getLegalFirstName',
      userImageUrl: 'getProfileImageUrl'
    })
  },
  methods: {
    async loadMoreReviews () {
      var client = this.$store.getters.getReviewApigClientFactory
      var params = {}
      var pathTemplate = '/reviews'
      var method = 'GET'
      var additionalParams = {
        queryParams: {
          business_id: this.businessId,
          last_evaluated_key: JSON.stringify(this.lastKey)
        }
      }
      var body = {}
      try {
        if (this.lastKey === null) {
          return
        }
        var reviews = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        for (var review in reviews.data.data) {
          this.homAptReviews.push(reviews.data.data[review])
        }
        this.lastKey = reviews.data.last_evaluated_key
      } catch (error) {
        console.log(error)
      }
    },
    setLoading () {
      if (this.isLoading) this.isLoading = false
      if (!this.isLoading) this.isLoading = true
    },
    async reload () {
      await this.getReviews()
      this.isLoading = false
    },
    async submitReview () {
      this.isLoading = true
      if (!this.setRating || !this.reviewText) {
        this.dataNotFilledIn = true
        this.isLoading = false
        return
      }
      if (!this.getIdProvider) {
        this.notSignedIn = true
        this.isLoading = false
        return
      }
      if (!this.getLegalFirstName) {
        this.noName = true
        this.isLoading = false
        return
      }
      if (this.getUserType !== 'user') {
        this.mustBeUser = true
        this.isLoading = false
        return
      }
      var client = this.$store.getters.getReviewApigClientFactory
      var params = {}
      var pathTemplate = '/reviews'
      var method = 'POST'
      var additionalParams = {}
      var body = {
        reviewer_name: this.getLegalFirstName,
        business_id: this.businessId,
        reviewer_profile_image: this.userImageUrl,
        rating: this.setRating,
        review: this.reviewText
      }
      try {
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        await this.getReviews()
        this.setRating = null
        this.yourRating = null
        this.reviewText = ''
        this.dataNotFilledIn = false
        this.notSignedIn = false
        this.noName = false
        this.mustBeUser = false
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log(error)
      }
    },

    async getReviews () {
      var client = this.$store.getters.getReviewApigClientFactory
      var params = {}
      var pathTemplate = '/reviews'
      var method = 'GET'
      var additionalParams = {
        queryParams: {
          business_id: this.businessId
        }
      }
      var body = {}
      try {
        var reviews = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.homAptReviews = reviews.data.data
        this.lastKey = reviews.data.last_evaluated_key
      } catch (error) {
        console.log(error)
      }
    },

    previewImage: function (event) {
      var input = event.target
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = (e) => {
          this.imageData.push(e.target.result)
        }
        reader.readAsDataURL(input.files[0])
      }
    },

    removeImage (index) {
      this.imageData.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.no-padding {
  margin-top: 1rem;
}

.btn-primary {
  margin-top: 1rem;
  margin-bottom: 5px;
}

.fa-star {
  font-size: 2rem;
  color: orange;
}

.padding-bottom {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/business/subnavItems/Reviews.vue